import e from"react";const t=({children:t})=>t?e.createElement("div",{className:"text-sm text-color-subtle"},t):null;export{t as default};
